import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, } from "react-hook-form";
import { checkAccess } from '../../../actions/securityactions'
import CustomPager from '../../../components/custompager';
import * as actions from '../actions/complaintandfeedbackactions.js'
import * as appConstants from '../../../overrides/appconstants.js'
import CustomModal from '../../../components/CustomModal'
import ReCAPTCHA from "react-google-recaptcha";
import complaintsservice from '../services/complaintandfeedbackservice.js'
import * as appActions from '../../../actions/appactions';
import { uploadFile } from '../../../infrastructure/httphelper';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';

export default function NewComplaint() {
    const state = useSelector(state => state.complaintandfeedbackReducer);
    let modalsState = state.modalsState;
    let masters = state.masters;
    let complaintDetails = state.complaintDetails;
    const refTabs = useRef(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const navigate = useNavigate();

    const { register: registerNewComplaint, handleSubmit: handleSubmitNewComplaint, setValue: setNewComplaintValue, reset: resetNewComplaint,
        formState: { errors: errorsNewComplaint }, watch } = useForm({
        });
    let newComplaint = state.newComplaint;
    let validationsErrorMessages = state?.validationsErrorMessages;
    const [phoneMessage, setphoneMessage] = useState(null);
    const [emailMessage, setemailMessage] = useState(null);
    const [eIdMessage, seteIdMessage] = useState(null);
    const [localErrors, setLocalErrors] = useState(errorsNewComplaint || {});
    const [captchaCompleted, setCaptchaCompleted] = useState(false);
    const [captchaError, setCaptchaError] = useState(false);


    useEffect(() => {
        let valuesToMap = [
            { "sourceName": newComplaint.sourceName },
            { "fullName": newComplaint.fullName },
            { "email": newComplaint.email },
            { "mobileNumber": newComplaint.mobileNumber },
            { "complaintNumber": newComplaint.complaintNumber },
            { "plateNumber": newComplaint.plateNumber },
            { "policyNumber": newComplaint.policyNumber },
            { "statusName": newComplaint.statusName },
            { "lineOfBuisness": newComplaint.lineOfBuisness },
            { "subject": newComplaint.subject },
            { "openingDate": newComplaint.openingDate },
            { "membershipNumber": newComplaint.membershipNumber },
            { "make": newComplaint.make },
            { "claimNumber": newComplaint.claimNumber },
            { "comment": newComplaint.comment },
            { "emiratesId": newComplaint.emiratesId },
        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setNewComplaintValue(key, i[key])));
    }, [newComplaint]);

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onFileChange = async (e) => {
        if (!e.target || e.target.files.length == 0)
            return;
        let file = e.target.files[0];
        let docId = null;
        const inputName = e.target.name;
        // const docIdEncrypted = docId;
        const type = e.fileType;
        const field = "fileInput";
        const name = file.name;
        const date = new Date();
        const docIdEncrypted = await uploadFile(file);
        let id = 0;
        if (inputName == "selectedFile1") {
            id = 0;
        }
        if (inputName == "selectedFile2") {
            id = 1;
        }
        if (inputName == "selectedFile3") {
            id = 2;
        }
        dispatch(actions.updateFileChange({ id, field, name, docIdEncrypted, type, date }));
    };

    const handleNewComplaintChange = (e) => {
        let { name, value } = e.target;
        // if (name == "lineOfBuisness") {
        //     dispatch(actions.updateComplaintLOBState(true, value));
        // }
        if (name == "subLineOfBuisness") {
            dispatch(actions.updateComplaintTypeState(true, value));
        }
        // if (name == "mobileNumber") {
        //     const digitsOnly = value.replace(/\D/g, '');
        //     value = digitsOnly.substring(0, 18);
        //     //const regex = /^[2,3,4,6,7,8,9]{1}[1-9]{1}[0-9]{6}$|^[0]?[5][0,5,2,6,4,8]{1}[1-9]{1}[0-9]{6}$/;
        //     const regex = /^5[0-9]{8}$/;
        //     dispatch(actions.updateNewComplaintParams({ name, value }));
        //     if (!regex.test(value)) {
        //         setphoneMessage("Invalid Phone Number");
        //         dispatch(actions.changeValidationMessage({ name: 'phoneMessage', value: "Invalid Phone Number" }))
        //         return;
        //     }
        //     setphoneMessage(null);
        //     dispatch(actions.changeValidationMessage({ name: 'phoneMessage', value: null }))
        // }
        if (name == "email") {
            const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            dispatch(actions.updateNewComplaintParams({ name, value }));
            if (!emailRegex.test(value)) {
                setemailMessage("Invalid Email ID");
                dispatch(actions.changeValidationMessage({ name: 'emailMessage', value: "Invalid Email Id" }))
                return;
            }
            setemailMessage(null);
            dispatch(actions.changeValidationMessage({ name: 'emailMessage', value: null }))
        }
        if (name == "emiratesId") {
            const digitsOnly = value.replace(/\D/g, '');
            let formattedValue = '';
            for (let i = 0; i < digitsOnly.length; i++) {
                if (i === 3 || i === 7 || i === 14) {
                    formattedValue += '-';
                }
                formattedValue += digitsOnly.charAt(i);
            }
            console.log('formattedValue', formattedValue);
            value = formattedValue.substring(0, 18);
            let prefix = value.substring(0, 6)
            if (value.substring(0, 3) != "784") {
                dispatch(actions.updateNewComplaintParams({ name, value }));
                seteIdMessage("Invalid Emirates ID");
                dispatch(actions.changeValidationMessage({ name: 'eIdMessage', value: "Invalid Emirates ID" }))
                return;
            }
            let eidTests = ["7", "78", "784", "784-", "784-1", "784-19", "784-2", "784-20"]
            if (!eidTests.includes(prefix)) {
                dispatch(actions.updateNewComplaintParams({ name, value }));
                seteIdMessage("Invalid Emirates ID");
                dispatch(actions.changeValidationMessage({ name: 'eIdMessage', value: "Invalid Emirates ID" }))
                return;
            }
            seteIdMessage(null);
            dispatch(actions.changeValidationMessage({ name: 'eIdMessage', value: null }))
        }
        dispatch(actions.updateNewComplaintParams({ name, value }));
        if (name == "termsCheckbox") {
            let { name, checked } = e.target;
            let value = checked;
            dispatch(actions.updateNewComplaintParams({ name, value }));
        }
       
        
    }

    const handleCaptchaChange = (value) => {
        if (value) {
            setCaptchaCompleted(true);
            setCaptchaError(false);
        } else {
            setCaptchaCompleted(false);
            setCaptchaError(true);
            {
                let dialogeData = {
                       message: `Please complete the CAPTCHA.`,
                       showConfirmPopup: true,
                       isConfirm: false,
                       isInfo: true,
                     }
               
                      dispatch(actions.toggleConfirmPopup(dialogeData));
                     return true;
             }
        }
    };

    const onSubmitNewComplaint = async () => {
        if (!captchaCompleted) {
            setCaptchaError(true);
            {
                let dialogeData = {
                       message: `Please complete the CAPTCHA.`,
                       showConfirmPopup: true,
                       isConfirm: false,
                       isInfo: true,
                     }
               
                     await dispatch(actions.toggleConfirmPopup(dialogeData));
                     return true;
             }
           
        }
        if(newComplaint.termsCheckbox != true)
        {
           let dialogeData = {
                  message: `Please Approve Terms & Condition!`,
                  showConfirmPopup: true,
                  isConfirm: false,
                  isInfo: true,
                }
          
                await dispatch(actions.toggleConfirmPopup(dialogeData));
                return true;
        }
         {
            setIsButtonDisabled(true);
            try {
        await dispatch(actions.saveComplaintInfo());
       // await dispatch(actions.saveDocuments());
        }
    catch (error) {
        console.error("Error saving complaint details:", error);
      } finally {
        // Enable the button after the function completes
        setIsButtonDisabled(false);
      }
    }

    }

    const scrollToTabs = () => {
        refTabs.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const onErrorNewComplaint = (errorsNewComplaint, e) => console.log(errorsNewComplaint, e);
    console.log("newComplaint", newComplaint);
    const dispatch = useDispatch();

    const onResetNewComplaint = (e) => {
        resetNewComplaint();
        dispatch(actions.resetNewComplaintParamsWithoutComplaint());
    }

    const onPageChangeRequest = async (page) => {
    }

    const updateSortString = async (val) => {
    }

    function renderNewComplaint() {
        let ComplaintType =
            <select
                className={errorsNewComplaint.sourceName ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="sourceName"
                name="sourceName"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                {...registerNewComplaint("sourceName",
                    {
                        required: true,
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            >
                <option value="">--Select Type--</option>
                {masters.compliantTypeMasters.map((compliantTypeMaster) => (
                    <option value={compliantTypeMaster.domainValue} key={compliantTypeMaster.domainValue}>
                        {compliantTypeMaster.domainValueName}
                    </option>
                ))}
            </select>

        let FullName =
            <input
                className={errorsNewComplaint.fullName ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Full Name"
                id="fullName"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                name="fullName"
                type="text"
                {...registerNewComplaint("fullName",
                    {
                        required: true,
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            // onChange={handleNewComplaintChange}
            // value={treatySearch.treatyCode}
            />

        let Email =
            <input
                className={errorsNewComplaint.email || emailMessage ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Email"
                id="email"
                name="email"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                type="text"
                {...registerNewComplaint("email", {
                    required: true,
                    validate: {
                        emailcheck: (v) => isValidEmail(v)
                    },
                    onChange: (e) => handleNewComplaintChange(e)
                })}
            // value={treatySearch.treatyCode}
            />
           
        // let MobileNumber =
        //     <input
        //         className={errorsNewComplaint.mobileNumber || phoneMessage ? 'form-control is-invalid' : 'form-control'}
        //         placeholder="5X XXXXXXX / X XXXXXXX"
        //         id="mobileNumber"
        //         name="mobileNumber"
        //         //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
        //         type="text"
        //         {...registerNewComplaint("mobileNumber", {
        //             required: true,
        //             pattern: {
        //                 value: /^5[0-9]{8}$/,
        //                 ///^[0]?[2,3,4,6,7,8,9]{1}[-]?[0-9]{7}$|^[0]?[5][0,5,2,6,4,8]{1}[-]?[0-9]{7}$/,
        //                 message: "Format: 5X XXXXXXX / X XXXXXXX"
        //             },
        //             onChange: (e) => handleNewComplaintChange(e)
        //         })}
        //     // value={treatySearch.treatyCode}
        //     />
        let MobileNumber = <input className={errorsNewComplaint.mobileNumber ? 'form-select is-invalid' : 'form-control'}
        //placeholder="05X-XXXXXXX / 0X-XXXXXXX"
        placeholder="5XXXXXXXX"
        id="mobileNumber"
        name="mobileNumber"
        type="text"
        {...registerNewComplaint("mobileNumber", {
            required: true,
            //pattern: { value: /(^[0][5][0,5,2,6,4,8]{1}[-]?[0-9]{7}$)|(^[0][2,3,4,5,6,7,9]{1}[-]?[0-9]{7}$)/, message: "Format: 05X-XXXXXXX / 0X-XXXXXXX" },
            pattern: { value: /(^[5][0,5,2,6,4,8]{1}[0-9]{7}$)/, message: "Format: 5XXXXXXXX" },
            onChange: (value) => handleNewComplaintChange(value)
        })}
    />

        let PolicyNumber =
            <input
                className={errorsNewComplaint.policyNumber ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Policy Number"
                id="policyNumber"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                name="policyNumber"
                type="text"
                {...registerNewComplaint("policyNumber",
                    {
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            // onChange={handleNewComplaintChange}
            // value={treatySearch.treatyCode}
            />

        let Subject =
            <input
                className={errorsNewComplaint.subject ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter subject"
                id="subject"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                name="subject"
                type="text"
                {...registerNewComplaint("subject",
                    {
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            // onChange={handleNewComplaintChange}
            // value={treatySearch.treatyCode}
            />

        let Status =
            <select
                className={errorsNewComplaint.statusName ? 'form-control is-invalid' : 'form-select'}
                data-toggle="select2"
                id="statusName"
                name="statusName"
                disabled={true}
                value={newComplaint.statusName}
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                {...registerNewComplaint("statusName",
                    {
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            >
                <option value="">--Select Status--</option>
                {masters.statusMasters.map((statusMasters) => (
                    <option value={statusMasters.statusId} key={statusMasters.statusId}>
                        {statusMasters.statusName}
                    </option>
                ))}
            </select>

        let LineOfBuisness =
            <select
                className={errorsNewComplaint.lineOfBuisness ? 'form-select is-invalid' : 'form-select'}
                data-toggle="select2"
                id="lineOfBuisness"
                name="lineOfBuisness"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                {...registerNewComplaint("lineOfBuisness",
                    {
                        required: true,
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            >
                <option value=''>--Product--</option>
                {masters.lobMasters.map((lobMasters) => (
                    <option value={lobMasters.lobId} key={lobMasters.lobId}>
                        {lobMasters.lobName}
                    </option>
                ))}
            </select>
 let EmiratesId = <input className={errorsNewComplaint.emiratesId || eIdMessage ? 'form-control is-invalid' : 'form-control'}
 placeholder=" XXX-XXXX-XXXXXXX-X"
 id="emiratesId"
 //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
 name="emiratesId"
 
 type="text"
 {...registerNewComplaint("emiratesId", { pattern: { value: /(^[7][8][4][-][0-9]{4}[-][0-9]{7}[-][0-9]{1}$)|(^[1][1][1][-][1]{4}[-][1]{7}[-][1]{1}$)/, message: "Format: XXX-XXXX-XXXXXXX-X" },
     required: newComplaint.lineOfBuisness == appConstants.LOP_TYPE_MEDICAL,
     onChange: (e) => handleNewComplaintChange(e) })}

// onChange={handleNewComplaintChange}
// value={treatySearch.treatyCode}
/>
        let SubmissionDt =
            <input
                className={errorsNewComplaint.openingDate ? 'form-control is-invalid' : 'form-control'}
                type="date"
                id="openingDate"
                required=""
                disabled={true}
                placeholder="Enter Reply Date By Source"
                name='openingDate'
                {...registerNewComplaint("openingDate",
                    { onChange: (e) => handleNewComplaintChange(e) })}
            //value={appUtility.formatDate(treatySearch.ToDate)}
            />

        let MembershipNumber =
            <input
                className={errorsNewComplaint.membershipNumber ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Membership Number"
                id="membershipNumber"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                name="membershipNumber"
                type="text"
                {...registerNewComplaint("membershipNumber",
                    { /* required: true, */
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            // onChange={handleNewComplaintChange}
            // value={treatySearch.treatyCode}
            />

        let Make = <select className={errorsNewComplaint.make ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2" id="make" name="make" isSearchable //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
            {...registerNewComplaint("make", {
                required: {
                    // value: newComplaint.subLineOfBuisness == 1
                }, onChange: (e) => handleNewComplaintChange(e)
            })}
        >
            <option value=''>--Vehicle Type--</option>
            {masters.makeMasters.map((makeMasters) => (
                <option value={makeMasters.makeId} key={makeMasters.makeId}>
                    {makeMasters.makeName}
                </option>
            ))}
        </select>

        let VehicleNumber =
            <input
                className={errorsNewComplaint.plateNumber ? 'form-control is-invalid' : 'form-control'}
                placeholder="Enter Vehicle Number"
                id="plateNumber"
                //disabled={complaintDetails.statusName == appConstants.STATUS_CLOSE && newComplaint.complaintNumber != null}
                name="plateNumber"
                type="text"
                {...registerNewComplaint("plateNumber",
                    { /* required: true, */
                        onChange: (e) => handleNewComplaintChange(e)
                    })}
            // onChange={handleNewComplaintChange}
            // value={treatySearch.treatyCode}
            />

        let Message = <textarea className={errorsNewComplaint.comment ? 'form-control is-invalid' : 'form-control'}
            class="form-control" aria-label="With textarea"
            placeholder=""
            id="comment"
            rows={5}
            // style={{ width: "1500px", height: "200px" }}
            name="comment"
            type="textArea"
            {...registerNewComplaint("comment", { required: true, onChange: (e) => handleNewComplaintChange(e) })}
            textarea />


        let TermsandConditions =
        <input
    type="checkbox"
    id="termsCheckbox"
    className={`form-check-input ${errorsNewComplaint.termsCheckbox ? 'is-invalid' : 'form-check-input'}`}
    name="checkbox"
    style={{ width: "15px", height: "15px" }}
    checked={newComplaint.termsCheckbox}
    value={newComplaint.termsCheckbox}
    {...registerNewComplaint("termsCheckbox", { 
        required: false, 
        onChange: (e) => handleNewComplaintChange(e) 
    })}
/>

// {errorsNewComplaint.termsCheckbox && 
//     dispatch(appActions.showMessage("Kindly check the Terms and Condition", { buttons: ['Ok'] })) &&
//     <div className="text-danger">Kindly check the Terms and Condition</div>
//  }

   
        let Captcha = <ReCAPTCHA
            sitekey={appConstants.CAPTCHA_SITE_KEY}
            // sitekey="6Lflq9QqAAAAACQYldy2S3ece4KtQCKS37F1dfEy"
            onChange={handleCaptchaChange}
        />
        let ComplaintNumber = <input className={errorsNewComplaint.complaintNumber ? 'form-control is-invalid' : 'form-control'}
            placeholder=" Complaint Number"
            id="complaintNumber"
            name="complaintNumber"
            disabled={true}
            type="text"
            {...registerNewComplaint("complaintNumber", { required: false, onChange: (e) => handleNewComplaintChange(e) })}

        // onChange={handleNewComplaintChange}
        // value={treatySearch.treatyName}
        />

        return (
            <>
                {/* <ul className="nav nav-tabs nav-bordered mb-3">
                    <li className="nav-item">
                        <a href="#form-row-preview" data-bs-toggle="tab" aria-expanded="false" className="nav-link ">
                        </a>
                    </li>
                </ul> */}
                <ul className="nav nav-tabs nav-bordered mb-3">
                </ul>
                <body /*data-layout-config="{&quot;darkMode&quot;:false}" data-layout-color="light"*/>

                     <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-xxl-6 col-lg-5">
                                    <div class="card">

                                        <div class="card-body p-4">

                                            <span class="logo-lg d-block mb-3">
                                            <div class="text-center w-75 m-auto">
                                                <h4 class="text-black text-center mt-0 mb-3 fw-bold"> Complaint and Feedback</h4>
                                            </div>
                                            </span>
                                            <ul className="nav nav-tabs nav-bordered my-3">
                                            </ul>


                                            <form className="form-group collapse show"
                                                onSubmit={handleSubmitNewComplaint(onSubmitNewComplaint, onErrorNewComplaint)}
                                                id="ColapseTargetComplaintDetails">
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"> Complaint Number/رقم الشكوى</label>
                                                    {ComplaintNumber}
                                                </div>
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Type/النوع</label>
                                                    {ComplaintType}
                                                </div>

                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Full Name/الأسم</label>
                                                    {FullName}
                                                </div>

                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Email ID/البريد الإلكتروني</label>
                                                    {Email}
                                                </div>

                                                <div className="position-relative mb-3">
                                                    <label htmlFor="inputPassword4" className="form-label"><span className='text-danger'>*</span> Mobile Number/رقم الموبايل</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text">+971</span>
                                                        </div>
                                                        {MobileNumber}
                                                    </div>
                                                    {(errorsNewComplaint.mobileNumber || phoneMessage) && (
                                                        <div className='text-danger'>
                                                            {errorsNewComplaint.mobileNumber?.message || phoneMessage}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Product/المنتج</label>
                                                    {LineOfBuisness}
                                                </div>
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label">
                                                       { (newComplaint.lineOfBuisness == appConstants.MEDICAL_LOB_MASTER) && <span className='redstar'>* </span>}
                                                         Emirates ID/الهوية الإماراتية</label>
                                                    {EmiratesId}
                                                </div>
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Policy Number/رقم الوثيقة (or) Claim Number/رقم المطالبة</label>
                                                    {PolicyNumber}
                                                </div>


                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Complaint Description/وصف الشكوى</label>
                                                    {Subject}
                                                </div>




                                                {(newComplaint.lineOfBuisness == appConstants.MEDICAL_LOB_MASTER) &&
                                                    <div className="mb-3">
                                                        <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Membership Number/رقم العضوية</label>
                                                        {MembershipNumber}
                                                    </div>
                                                }

                                                {(newComplaint.lineOfBuisness == appConstants.MOTOR_LOB_MASTER) &&
                                                    <div className="mb-3">
                                                        <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Vehicle Type/نوع المركبة</label>
                                                        {Make}
                                                    </div>
                                                }


                                                {(newComplaint.lineOfBuisness == appConstants.MOTOR_LOB_MASTER) &&
                                                    <div className="mb-3">
                                                        <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Vehicle Number/رقم المركبة</label>
                                                        {VehicleNumber}
                                                    </div>
                                                }

                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Status/الحالة</label>
                                                    {Status}
                                                </div>
                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label">{/* <span className='redstar'>*</span> */} Submission Date/تاريخ التقديم</label>
                                                    {SubmissionDt}
                                                </div>

                                                <div className="mb-3">
                                                    <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Complaint Details/تفاصيل الشكوى</label>
                                                    {Message}
                                                    {errorsNewComplaint.comment && <span className='redstar'> {errorsNewComplaint.comment.message}</span>}
                                                    <p className='mb-0'>{watch("comment", "")?.length ?? 0} / 3999</p>
                                                </div>

                                                <div class="mb-3">
                                                    <div className="row g-2">
                                                        <div className="mb-4 col-md-12">
                                                            <div className="row">
                                                                <label className="form-label">Document Upload/تحميل الوثيقة</label>
                                                                <div className="col-sm-6">
                                                                    <input className="form-control"
                                                                        type="file"
                                                                        id="inputGroupFile1"
                                                                        label="selectedFile1"
                                                                        name="selectedFile1"
                                                                        {...registerNewComplaint("selectedFile1", { onChange: (e) => onFileChange(e) })} />
                                                                </div>
                                                                <div className="col-sm-6 text-end">
                                                                    <input className="form-control"
                                                                        type="file"
                                                                        id="inputGroupFile2"
                                                                        label="selectedFile2"
                                                                        name="selectedFile2"
                                                                        {...registerNewComplaint("selectedFile2", { onChange: (e) => onFileChange(e) })} />
                                                                </div>
                                                                <div className="mt-3 col-sm-6">
                                                                    <input className="form-control"
                                                                        type="file"
                                                                        id="inputGroupFile3"
                                                                        label="selectedFile3"
                                                                        name="selectedFile3"
                                                                        {...registerNewComplaint("selectedFile3", { onChange: (e) => onFileChange(e) })} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mb-3">
                                                    <div class="form-check">
                                                        {TermsandConditions}
                                                        <label htmlFor="termsCheckbox" class="form-check text-justify" className="fs-6">
                                                            By consenting to this privacy notice you are giving us permission to process your personal data specifically for the purposes identified. Consent is required for ASNIC to process all types of personal data, but it must be explicitly given. Where we are asking you for sensitive personal data, we are always bound to tell you why and how the information will be used.
                                                            You may withdraw consent at any time by submitting ‘Data Subject Consent Withdrawal Request’ by writing to <a href="mailto:privacy@alsagrins.ae">privacy@alsagrins.ae</a>.
                                                            Please note that it will take us 30 days to complete the processing and give you a confirmation.
                                                        </label>
                                                    </div>

                                                </div>
                                                <div className="mb-3">
                                                    {Captcha}
                                                   {/* {captchaError && (<div className="invalid-feedback d-block">Please complete the CAPTCHA.</div>)} */}
                                                </div>
                                                {/* <div class="mb-3 text-center d-flex justify-content-center gap-3">
                                                    <button type="button" class="btn btn-success"title="Save" onClick={() => onSubmitNewComplaint()}> Register</button>

                                                </div> */}

                                                {/* <div id="tooltip-container2">
                                                    <button type="submit" className="btn btn-success float-end"
                                                        data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save"></i> Save</button>
                                                </div> */}

                                                <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                    // onClick={handleNext}
                                                    disabled={isButtonDisabled}
                                                    >
                                                        Save
                                                    </Button>

                                                </Box>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                     </div> 
                </body>
            </>
        )
    }

    return (
        <>
            {renderNewComplaint()}
        </>
    )
}

